module.exports = __webpack_public_path__ + "static/media/excel-download.c2593530.svg";